import React, { useEffect, useState } from "react";

import { Message } from "@twilio/conversations";
import { HiOutlineDocumentText } from "react-icons/hi";
import { LuLoader } from "react-icons/lu";

import ImageDialog from "./ImageDialog";

interface MediaMessageProps {
  message: Message;
}

const MediaMessage: React.FC<MediaMessageProps> = ({ message }) => {
  const [loading, setLoading] = useState(true);
  const [mediaUrl, setMediaUrl] = useState<string | null>(null);
  const [isImageDialogOpen, setIsImageDialogOpen] = useState(false);

  useEffect(() => {
    getMediaUrl();
  }, [message]);

  const getMediaUrl = () => {
    if (message.attachedMedia && message.attachedMedia.length > 0) {
      const firstMedia = message.attachedMedia[0] as any;

      // If the URL is already present (from backend mapping), use it directly
      if (firstMedia.url) {
        setMediaUrl(firstMedia.url);
        setLoading(false);
        return;
      }

      // Otherwise, try to call the SDK method if it exists
      if (typeof firstMedia.getContentTemporaryUrl === "function") {
        return firstMedia.getContentTemporaryUrl().then((url: string) => {
          setLoading(false);
          setMediaUrl(url);
        });
      }
    }
  };

  const displayMedia = () => {
    if (!mediaUrl) {
      return null;
    }
    if (message.attachedMedia?.[0].contentType.startsWith("image/")) {
      return (
        <>
          <ImageDialog
            imageUrl={mediaUrl}
            onClose={() => {
              setIsImageDialogOpen(false);
            }}
            isOpen={isImageDialogOpen}
          />
          <button
            type="button"
            className="cursor-pointer border-0 bg-transparent p-0"
            onClick={() => {
              setIsImageDialogOpen(true);
            }}
          >
            <img
              src={mediaUrl}
              alt={message?.attachedMedia?.[0].filename || "Attachment"}
              className="h-auto max-w-full rounded-lg"
            />
          </button>
        </>
      );
    } else {
      return (
        <button
          type="button"
          className="flex cursor-pointer items-center gap-2 border-0 bg-transparent p-0 text-left"
          onClick={() => {
            window.open(mediaUrl, "_blank");
          }}
        >
          <HiOutlineDocumentText className="h-7 w-7" />
          <span>{message?.attachedMedia?.[0].filename || "Document"}</span>
        </button>
      );
    }
  };

  return (
    <div className="media-message">
      {loading || !mediaUrl ? (
        <div className="loading">
          <LuLoader className="w-4 h-4 animate-spin" />
        </div>
      ) : (
        displayMedia()
      )}
    </div>
  );
};

export default MediaMessage;
